import React, { Suspense } from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { createRoot } from "react-dom/client";
// import myLogo from "./assets/images/logo.png";
// import * as serviceWorkerRegistration from "./service-worker";

import Spinner from "./components/spinner/Spinner";
// import { stopReportingRuntimeErrors } from 'react-error-overlay';

// if (process.env.NODE_ENV === "development") {
//   stopReportingRuntimeErrors(); // disables error overlays
// }

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>
    </Provider>
  </React.StrictMode>
);

// serviceWorkerRegistration.register({
//   onUpdate: (registration) => {
//     const confirmationMessage = `New update is available. Click OK to reload.`;
//     if (window.confirm(confirmationMessage)) {
//       registration.waiting.postMessage({ type: "SKIP_WAITING" });
//     }
//   },
// });

reportWebVitals();
